var _class, _descriptor;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import Store from "@ember-data/store";
import ModelRegistry from "@ember-data/types/registries/model";
import { assert } from "@ember/debug";
import Service, { service } from "@ember/service";
import Medic from "core/models/medic";
import Patient from "core/models/patient";
export let Configuration = /*#__PURE__*/function (Configuration) {
  Configuration["VitalSign"] = "configuration-vital-sign";
  Configuration["Consultation"] = "configuration-consultation";
  Configuration["BioExam"] = "configuration-bio-exam";
  return Configuration;
}({});
let ConfigurationService = (_class = class ConfigurationService extends Service {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "store", _descriptor, this);
  }
  static configurationIdForPatient(feature, patient) {
    return ConfigurationService.configurationId(feature, "patient", patient.id);
  }
  static configurationIdForMedic(feature, medic) {
    return ConfigurationService.configurationId(feature, "medic", medic.id);
  }
  static configurationId(feature, layer, id) {
    return `${feature.replace("configuration-", "")}_${layer}-${id}`;
  }
  async fetchConfigurationsForPatient(patient) {
    const features = [Configuration.VitalSign, Configuration.Consultation, Configuration.BioExam];
    return Promise.all(features.map(feature => {
      const configId = ConfigurationService.configurationIdForPatient(feature, patient);
      return this.store.findRecord(feature, configId);
    }));
  }
  async fetchConfigurationForMedic(feature, medic) {
    const configId = ConfigurationService.configurationIdForMedic(feature, medic);
    return await this.store.findRecord(feature, configId);
  }
  configurationForPatient(feature, patient) {
    const record = this.store.peekRecord(feature, ConfigurationService.configurationIdForPatient(feature, patient));
    assert(`No configuration found in store for patient ${patient.id}. This means the configuration has not been fetched first`, Boolean(record));
    return record;
  }
  configurationForMedic(feature, medic) {
    const record = this.store.peekRecord(feature, ConfigurationService.configurationIdForMedic(feature, medic));
    assert(`No configuration found in store for medic ${medic.id}. This means the configuration has not been fetched first`, Boolean(record));
    return record;
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "store", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class);
export { ConfigurationService as default };